var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser ||
    _vm.$userInfo.isCustomerAdministrator ||
    _vm.$userInfo.isSystemAdministrator
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c(
            "article",
            { staticClass: "tile is-child box" },
            [
              _c(
                "div",
                { staticClass: "columns is-flex is-align-items-center" },
                [
                  _vm._m(0),
                  !_vm.hasError &&
                  _vm.showSavingStatus &&
                  !_vm.toastNotificationEnabled
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "column is-flex is-justify-content-flex-end is-align-items-center",
                        },
                        [
                          _vm.saving
                            ? _c("span", {
                                staticClass: "button is-loading is-white",
                                staticStyle: { height: "27px" },
                              })
                            : _c(
                                "span",
                                { staticClass: "text has-text-success" },
                                [
                                  _c("span", { staticClass: "mso mso-18px" }, [
                                    _vm._v("check_circle"),
                                  ]),
                                ]
                              ),
                          _c(
                            "span",
                            {
                              staticClass: "is-size-6",
                              class: _vm.saving
                                ? "has-text-warning"
                                : "has-text-success",
                            },
                            [_vm._v(_vm._s(_vm.savingStatus))]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "field columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-half" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Base Modules"),
                    ]),
                    _vm._l(
                      _vm.companyBaseModules,
                      function (baseModule, index) {
                        return _c("div", { key: index }, [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-two-thirds" }, [
                              _vm._v(_vm._s(baseModule.modDesc)),
                            ]),
                            _c("div", { staticClass: "column is-one-third" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: baseModule.enabled,
                                        expression: "baseModule.enabled",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      disabled: !_vm.$userInfo.isSystemAccount,
                                    },
                                    domProps: {
                                      checked: Array.isArray(baseModule.enabled)
                                        ? _vm._i(baseModule.enabled, null) > -1
                                        : baseModule.enabled,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = baseModule.enabled,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                baseModule,
                                                "enabled",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                baseModule,
                                                "enabled",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(baseModule, "enabled", $$c)
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(1, true),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }
                    ),
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "column is-half" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Optional Modules"),
                    ]),
                    _vm._l(
                      _vm.companyOptionalModules,
                      function (optionalModule, index) {
                        return _c("div", { key: index }, [
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-two-thirds" }, [
                              _vm._v(_vm._s(optionalModule.modDesc)),
                            ]),
                            _c("div", { staticClass: "column is-one-third" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pretty p-icon p-curve p-smooth m-0 p-bigger",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: optionalModule.enabled,
                                        expression: "optionalModule.enabled",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      disabled: !_vm.$userInfo.isSystemAccount,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        optionalModule.enabled
                                      )
                                        ? _vm._i(optionalModule.enabled, null) >
                                          -1
                                        : optionalModule.enabled,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = optionalModule.enabled,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                optionalModule,
                                                "enabled",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                optionalModule,
                                                "enabled",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            optionalModule,
                                            "enabled",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._m(2, true),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }
                    ),
                  ],
                  2
                ),
              ]),
              _vm.selectedModuleIds.length > 0 && _vm.$userInfo.isSystemAccount
                ? _c("company-permission-records-setting", {
                    ref: "refCompanyPermissionRecords",
                    attrs: { "selected-module-ids": _vm.selectedModuleIds },
                  })
                : _vm._e(),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Modules")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("span", { staticClass: "icon mso mso-24px" }, [_vm._v("check")]),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }